<template>
  <div id="app">
    <nav-bar></nav-bar>
    <router-view />
    <bottom></bottom>
  </div>
</template>

<style>
#app {
  max-width: 100vw;
  min-width: 1226px;
}
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 0px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 2px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: #00bcd4;
  box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: #00bcd4;
}
</style>

<script>
import NavBar from '@/components/NavBar';
import Bottom from '@/components/Bottom';
export default {
  components: {
    NavBar,
    Bottom
  }
};
</script>
